(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moka-floating-inquiry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moka-floating-inquiry')) {
    customElements.define('moka-floating-inquiry', class extends HTMLElement {
      connectedCallback() {
        const trigger=this.querySelector('[data-trigger]');
        const layer=this.querySelector('[data-layer]');
        const panel=this.querySelector('[data-panel]');
        const form=this.querySelector('[data-form]');
        const email=this.querySelector('#MokaFloatingInquiryEmail');
        const success=this.querySelector('[data-success]');
        const errors=this.querySelector('[data-errors]');
        const context=this.querySelector('[data-context]');
        let returnFocus;
        const close=()=>{ if(layer.hidden)return; layer.hidden=true; trigger.setAttribute('aria-expanded','false'); if(returnFocus&&document.contains(returnFocus))returnFocus.focus(); };
        const open=(result=false)=>{ if(!layer.hidden)return; returnFocus=document.activeElement; layer.hidden=false; trigger.setAttribute('aria-expanded','true'); requestAnimationFrame(()=> (result?(errors.hidden?success:errors):email).focus()); };
        const source=form.querySelector('[data-source]');
        const product=form.querySelector('[data-product]');
        const model=form.querySelector('[data-model]');
        const message=form.querySelector('[data-bd-inquiry-message]');
        const body=form.querySelector('[data-bd-inquiry-body]');
        const storageKey='bd-inquiry/v1:'+form.id+':'+window.location.pathname;
        const read=(key)=>{try{return window.sessionStorage.getItem(key)||'';}catch(error){return '';}};
        const write=(key,value)=>{try{window.sessionStorage.setItem(key,value);}catch(error){}};
        const remove=(key)=>{try{window.sessionStorage.removeItem(key);}catch(error){}};
        const normalizeMeta=(value)=>String(value||'').replace(/\r\n?|\n/g,' ').replace(/[\u0000-\u001F\u007F]/g,' ').replace(/\s+/g,' ').trim().slice(0,2048);
        const normalizeMessage=(value)=>String(value||'').replace(/\r\n?/g,'\n').trim();
        const language=()=>{const value=normalizeMeta(document.documentElement.lang).replace(/_/g,'-');return /^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(value)?value:'en';};
        const createUuid=()=>{if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID().toLowerCase();const bytes=new Uint8Array(16);window.crypto.getRandomValues(bytes);bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128;return Array.from(bytes,(byte,index)=>[4,6,8,10].includes(index)?'-'+byte.toString(16).padStart(2,'0'):byte.toString(16).padStart(2,'0')).join('');};
        const identifier=()=>{const existing=read(storageKey+':submission_id');if(/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing))return existing.toLowerCase();const value=createUuid();write(storageKey+':submission_id',value);return value;};
        const buildBody=()=>{const value=normalizeMeta(model&&model.value);const meta={version:'bd-inquiry/1',submission_id:identifier(),product:normalizeMeta(product&&product.value),model:value==='Default Title'?'':value,source_page:window.location.origin+window.location.pathname,page_language:language()};return ['[BD_INQUIRY_BEGIN]',JSON.stringify(meta),'[BD_MESSAGE_BEGIN]',normalizeMessage(message&&message.value),'[BD_MESSAGE_END]','[BD_INQUIRY_END]'].join('\n');};
        const prepare=(event)=>{const payload=buildBody();body.value=payload;if(event)event.formData.set('contact[body]',payload);};
        const setContext=()=>{if(source)source.value=window.location.pathname;if(!context||!product.value)return;context.textContent=[product.value,model.value&&model.value!=='Default Title'?model.value:''].filter(Boolean).join('\n');context.hidden=false;};
        if(!success.hidden){remove(storageKey+':submission_id');remove(storageKey+':message');}else if(!errors.hidden){const savedMessage=read(storageKey+':message');if(savedMessage)message.value=savedMessage;}
        form.addEventListener('submit',()=>{write(storageKey+':message',message.value);prepare();});
        form.addEventListener('formdata',prepare);
        setContext();
        trigger.addEventListener('click',()=>open());
        this.querySelectorAll('[data-close]').forEach((button)=>button.addEventListener('click',close));
        panel.addEventListener('keydown',(event)=>{ if(event.key==='Escape'){event.preventDefault();close();} if(event.key!=='Tab')return; const items=[...panel.querySelectorAll('button:not([disabled]),input:not([disabled]),textarea:not([disabled])')]; const first=items[0],last=items[items.length-1]; if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();} else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();} });
        if (!success.hidden || !errors.hidden) open(true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moka-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new WeakMap();

  const init = header => {
    if (instances.has(header)) return;

    const root = header.querySelector('[data-moka-mega-root]');
    const panel = root?.querySelector('[data-moka-mega]');
    const trigger = root?.querySelector('[data-moka-mega-toggle]');
    const grid = panel?.querySelector('[data-moka-product-grid]');
    const scroller = panel?.querySelector('[data-moka-product-scroll]');
    const scrollbar = panel?.querySelector('[data-moka-scrollbar]');
    const thumb = panel?.querySelector('[data-moka-thumb]');
    const title = panel?.querySelector('[data-moka-preview-title]');
    const view = panel?.querySelector('[data-moka-collection-link]');
    const status = panel?.querySelector('[data-moka-status]');
    const empty = panel?.querySelector('[data-moka-empty]');
    if (!root || !panel || !trigger || !grid || !scroller || !scrollbar || !thumb || !title || !view || !status || !empty) return;

    const categories = [...panel.querySelectorAll('[data-moka-category]')];
    const parents = categories.filter(row => row.hasAttribute('data-moka-parent'));
    const childLists = [...panel.querySelectorAll('[data-moka-child-list]')];
    const preloaded = new Map(
      [...panel.querySelectorAll('[data-moka-preloaded-panel]')].map(node => [node.dataset.collectionId, node])
    );
    const toggle = header.querySelector('[data-moka-mobile-toggle]');
    const drawer = document.getElementById(toggle?.getAttribute('aria-controls'));
    const branches = [...header.querySelectorAll('[data-moka-branch]')];
    const listeners = [];
    const on = (element, type, handler, options) => {
      if (!element) return;
      element.addEventListener(type, handler, options);
      listeners.push(() => element.removeEventListener(type, handler, options));
    };
    const isSingle = () => header.dataset.mokaLayout === 'single';
    const isOpen = () => header.hasAttribute('data-moka-mega-open');
    const initial = parents.find(row => row.dataset.collectionId === panel.dataset.defaultId) || parents[0];
    const positions = new Map();

    let active = null;
    let parentId = '';
    let openTimer = 0;
    let closeTimer = 0;
    let selectTimer = 0;
    let scrollFrame = 0;
    let drag = null;
    let suppressFocus = false;
    let currentMode = header.dataset.mokaLayout;
    let lastPoint = null;
    let corridorUntil = 0;

    const cardsFor = row => {
      const source = preloaded.get(row.dataset.collectionId);
      return source ? [...source.querySelectorAll('[data-moka-card]')] : [];
    };

    const syncScrollbar = () => {
      const max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      const height = scrollbar.clientHeight;
      const size = Math.min(height, Math.max(32, height * scroller.clientHeight / Math.max(1, scroller.scrollHeight)));
      const usable = max > 1 && height > 0;
      const position = max ? Math.max(0, Math.min(max, scroller.scrollTop)) / max * (height - size) : 0;

      scrollbar.setAttribute('aria-valuemax', String(Math.round(max)));
      scrollbar.setAttribute('aria-valuenow', String(Math.round(Math.max(0, Math.min(max, scroller.scrollTop)))));
      scrollbar.setAttribute('aria-disabled', String(!usable));
      scrollbar.tabIndex = usable ? 0 : -1;
      thumb.hidden = !usable;
      thumb.style.height = size + 'px';
      thumb.style.transform = 'translateY(' + position + 'px)';
    };

    const scheduleScrollbar = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        syncScrollbar();
      });
    };

    const stopDrag = () => {
      if (drag && scrollbar.hasPointerCapture(drag.id)) scrollbar.releasePointerCapture(drag.id);
      drag = null;
      scrollbar.classList.remove('is-dragging');
    };

    const moveScrollbar = (clientY, offset) => {
      const max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      const travel = scrollbar.clientHeight - thumb.getBoundingClientRect().height;
      if (travel <= 0) return;
      const trackTop = scrollbar.getBoundingClientRect().top + scrollbar.clientTop;
      scroller.scrollTop = Math.max(0, Math.min(1, (clientY - trackTop - offset) / travel)) * max;
      syncScrollbar();
    };

    const save = () => {
      if (active) positions.set(active.dataset.collectionId, scroller.scrollTop);
    };

    const setHierarchy = row => {
      parentId = row.dataset.parentId;
      childLists.forEach(list => { list.hidden = list.dataset.parentId !== parentId; });
      categories.forEach(category => {
        const isParent = category.hasAttribute('data-moka-parent');
        const selected = isParent
          ? category.dataset.collectionId === parentId
          : category.dataset.collectionId === row.dataset.collectionId && category.dataset.parentId === parentId;
        category.classList.toggle('is-active', selected);
        category.querySelector('a')?.setAttribute('aria-pressed', String(selected));
      });
    };

    const select = row => {
      if (!row || !isOpen() || !isSingle()) return;
      if (active?.dataset.collectionId === row.dataset.collectionId && parentId === row.dataset.parentId) return;

      save();
      active = row;
      setHierarchy(row);
      title.textContent = row.dataset.title;
      view.href = row.dataset.url;

      const fragment = document.createDocumentFragment();
      cardsFor(row).forEach(card => fragment.append(card.cloneNode(true)));
      grid.replaceChildren(fragment);

      const count = grid.querySelectorAll('[data-moka-card]').length;
      empty.hidden = count > 0;
      scroller.setAttribute('aria-busy', 'false');
      status.textContent = count ? panel.dataset.loaded.replace('[count]', String(count)) : panel.dataset.empty;
      scroller.scrollTop = positions.get(row.dataset.collectionId) || 0;
      scheduleScrollbar();
    };

    const open = () => {
      clearTimeout(closeTimer);
      if (!isSingle() || isOpen()) return;
      panel.hidden = false;
      header.setAttribute('data-moka-mega-open', '');
      header.closest('.moka-header-section')?.classList.remove('is-moka-header-hidden');
      header.style.setProperty('--moka-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      trigger.setAttribute('aria-expanded', 'true');
      const selected = active || initial;
      active = null;
      select(selected);
    };

    const close = (restore = false) => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      clearTimeout(selectTimer);
      stopDrag();
      save();
      header.removeAttribute('data-moka-mega-open');
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (restore) {
        suppressFocus = true;
        trigger.focus();
        queueMicrotask(() => { suppressFocus = false; });
      }
    };

    const closeDrawer = (restore = false) => {
      drawer?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      if (restore) toggle?.focus();
    };

    const updateBranch = (button, expanded) => {
      const list = document.getElementById(button.getAttribute('aria-controls'));
      if (!list) return;
      list.hidden = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.collapse : button.dataset.expand;
    };

    const syncLayout = () => {
      const mode = header.dataset.mokaLayout;
      if (mode === 'measure' || mode === currentMode) return;
      currentMode = mode;
      if (mode === 'compact') {
        const focusInside = root.contains(document.activeElement);
        close();
        if (focusInside) toggle?.focus();
      } else {
        const focusInside = drawer?.contains(document.activeElement) || document.activeElement === toggle;
        closeDrawer();
        if (focusInside) trigger.focus();
      }
    };

    header.classList.add('moka-menu-enhanced');
    panel.hidden = true;
    childLists.forEach(list => { list.hidden = true; });
    categories.forEach(row => {
      const anchor = row.querySelector('a');
      anchor?.setAttribute('role', 'button');
      anchor?.setAttribute('aria-pressed', 'false');
    });
    branches.forEach(button => {
      updateBranch(button, false);
      on(button, 'click', () => updateBranch(button, button.getAttribute('aria-expanded') !== 'true'));
    });

    scrollbar.hidden = false;
    scroller.parentElement?.classList.add('is-custom-scrollbar');
    syncScrollbar();

    on(scrollbar, 'pointerdown', event => {
      if (event.button !== 0 || scrollbar.getAttribute('aria-disabled') === 'true' || !isOpen()) return;
      event.preventDefault();
      scrollbar.focus({ preventScroll: true });
      const offset = event.target === thumb ? event.clientY - thumb.getBoundingClientRect().top : thumb.getBoundingClientRect().height / 2;
      scrollbar.setPointerCapture(event.pointerId);
      drag = { id: event.pointerId, offset };
      scrollbar.classList.add('is-dragging');
      moveScrollbar(event.clientY, offset);
    });
    on(scrollbar, 'pointermove', event => { if (drag?.id === event.pointerId) moveScrollbar(event.clientY, drag.offset); });
    on(scrollbar, 'pointerup', stopDrag);
    on(scrollbar, 'pointercancel', stopDrag);
    on(scrollbar, 'lostpointercapture', stopDrag);
    on(scrollbar, 'keydown', event => {
      if (!isOpen() || scrollbar.getAttribute('aria-disabled') === 'true') return;
      const max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      const steps = { ArrowDown: 40, ArrowUp: -40, PageDown: scroller.clientHeight, PageUp: -scroller.clientHeight, Home: -max, End: max };
      if (!(event.key in steps)) return;
      event.preventDefault();
      scroller.scrollTop += steps[event.key];
      syncScrollbar();
    });

    on(toggle, 'click', () => {
      if (isSingle()) return;
      close();
      const expanded = drawer?.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(expanded));
    });
    on(trigger, 'click', () => { if (isOpen()) close(); else open(); });
    on(root, 'pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, 150);
    });
    on(root, 'pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      clearTimeout(selectTimer);
      closeTimer = setTimeout(() => {
        if (!root.contains(document.activeElement)) close();
      }, 250);
    });
    on(root.querySelector('.moka-mega__trigger > a'), 'focus', () => {
      if (!suppressFocus) open();
    });

    on(panel, 'pointermove', event => {
      if (event.pointerType !== 'mouse') return;
      const current = parents.find(row => row.dataset.collectionId === parentId);
      if (current && lastPoint) {
        const bounds = current.getBoundingClientRect();
        const direction = getComputedStyle(panel).direction === 'rtl' ? -1 : 1;
        const moving = (event.clientX - lastPoint.x) * direction > 0;
        if (moving && lastPoint.y >= bounds.top && lastPoint.y <= bounds.bottom && lastPoint.x >= bounds.left && lastPoint.x <= bounds.right) {
          corridorUntil = Date.now() + 300;
        }
      }
      lastPoint = { x: event.clientX, y: event.clientY };
    }, { passive: true });

    categories.forEach(row => {
      on(row, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(selectTimer);
        const delay = Math.max(160, Math.min(300, corridorUntil - Date.now()));
        selectTimer = setTimeout(() => select(row), delay);
      });
      on(row, 'pointerleave', () => clearTimeout(selectTimer));
      const anchor = row.querySelector('a');
      on(anchor, 'click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        clearTimeout(selectTimer);
        select(row);
      });
      on(anchor, 'keydown', event => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        clearTimeout(selectTimer);
        select(row);
      });
      on(anchor, 'focus', () => select(row));
    });

    on(scroller, 'scroll', scheduleScrollbar, { passive: true });
    on(window, 'resize', () => requestAnimationFrame(() => {
      syncLayout();
      scheduleScrollbar();
    }), { passive: true });
    on(header, 'focusout', event => {
      const check = next => {
        if (!root.contains(next)) close();
        if (!header.contains(next)) closeDrawer();
      };
      if (event.relatedTarget) check(event.relatedTarget);
      else setTimeout(() => check(document.activeElement), 0);
    });
    on(document, 'pointerdown', event => {
      if (!root.contains(event.target)) close();
      if (!header.contains(event.target)) closeDrawer();
    });
    on(header, 'keydown', event => {
      if (event.key !== 'Escape') return;
      if (isOpen()) {
        event.preventDefault();
        close(true);
        return;
      }
      let scope = document.activeElement?.closest('.moka-mobile-tree li');
      while (scope) {
        const button = scope.querySelector(':scope > .moka-mobile-tree__row > [data-moka-branch][aria-expanded="true"]');
        if (button) {
          event.preventDefault();
          updateBranch(button, false);
          button.focus();
          return;
        }
        scope = scope.parentElement?.closest('.moka-mobile-tree li');
      }
      if (drawer?.classList.contains('is-open')) {
        event.preventDefault();
        closeDrawer(true);
      }
    });

    instances.set(header, () => {
      close();
      listeners.splice(0).forEach(remove => remove());
      cancelAnimationFrame(scrollFrame);
      scrollbar.hidden = true;
      scroller.parentElement?.classList.remove('is-custom-scrollbar');
      instances.delete(header);
    });
  };

  const scan = scope => {
    if (scope.matches?.('.moka-header')) init(scope);
    scope.querySelectorAll?.('.moka-header').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.moka-header').forEach(header => instances.get(header)?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moka-product-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moka-product-quote')) {
    customElements.define('moka-product-quote', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        this.link = this.querySelector('a');
        if (!this.scope || !this.link) return;
        this.update = () => {
          const picker = this.scope.querySelector('variant-selects');
          const controls = picker ? Array.from(picker.querySelectorAll('select, fieldset')) : [];
          const control = controls[Number(this.dataset.modelIndex)];
          const fallbackModel = this.dataset.modelFallback || '';
          let model = control ? (control.tagName === 'SELECT' ? control.value : control.querySelector('input:checked')?.value || '') : this.dataset.model;
          if (!model || model === 'Default Title') model = fallbackModel;
          const url = new URL(this.link.href, window.location.origin);
          url.searchParams.set('model', model || '');
          this.link.href = url.toString();
        };
        this.scope.addEventListener('change', this.update);
        this.link.addEventListener('click', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.update);
        this.link?.removeEventListener('click', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
